export default {
  namespaced: true,
  hikvision_camera: {
    title: "Camera Hikvision | Cameras Hikvision",
    hikvision: 'hikvision',
    name: "name",
    dvr: "DVR",
    status: "status",
    type: "type",
  }
};
